import { createAuthClient } from 'better-auth/react';
import { organizationClient } from 'better-auth/client/plugins';
import { env } from '@/app/env';

/**
 * better-auth client for the ADMIN instance.
 *
 * A different instance from the platform app's, with a different secret and
 * different tables — never point this at the platform origin, and never lift
 * this file into a shared package. The isolation between the two auth surfaces
 * is a deliberate backend guarantee (see the backend's CLAUDE.md), and sharing
 * a client here would quietly undo it.
 *
 * Auth uses bearer tokens, not cookies.
 *
 * NOTE: nothing in the UI calls this yet — the auth module ships as screens
 * only.
 */
export const authClient = createAuthClient({
  baseURL: `${env.apiBaseUrl}/v1/auth`,
  plugins: [
    // Agencies are modelled as better-auth organizations; the admin app creates
    // them and issues the root-user invitation.
    organizationClient(),
  ],
});

export type AuthClient = typeof authClient;
